/**
 * Moduł obsługujący nowe główne menu strukturalnie współdzielone z headless
 * @type {module}
 */
app.service('headlessMenu',function(html, sticky, front, lazyLoad, loading) {
	let isInit = false, isMenuOpen = false, isAccountArea = false;
	let $self, $navToggle, $navToggleSticky, $menuCategories, $items, $uspItems, $accountAreaMenuToggle, $accountAreaMenu;

	let activeMenuCategory=null;
	let headlessMenuDebounceTimer;
	const DEBOUNCE_DELAY = 100; // ms

	// cache elementow DOM
	function setElements() {
		$self = $('#headless-main-menu');
		$navToggle = $('#nav-toggle');
		$navToggleSticky = $('#nav-toggle-sticky');
		$menuCategories = $('#categories-menu');
		$items = $menuCategories.find('.nav-category-item');
		$itemsContents = $menuCategories.find('.nav-category');
		$uspItems = $('#usp-menu li', $self);
		$accountAreaMenuToggle = $('#account-area-toggle a', $self);
		isAccountArea = $accountAreaMenuToggle.length ? true : false;
		$accountAreaMenu = $('#account-area-menu', $self);
	}

	function activateCategoryContent(menuItem) {
		const $menuItem = $(menuItem);
		const index = $menuItem.data('index');
		if (index === activeMenuCategory) {
			return;
		}
		html.add('menu-open');
		resetItems();
		$menuItem.addClass('active');

		$itemsContents.filter(`[data-index="${index}"]`).addClass('active');
		activeMenuCategory = index;
		lazyLoad.check();
	}

	function resetItems() {
		$items.removeClass('active');
		$itemsContents.removeClass('active');
		activeMenuCategory = null;
	}

	function openMainMenu() {
		if(isMenuOpen) {
			return;
		}
		if (isAccountArea) {
			closeAccountAreaMenu();
		}
		$navToggle.addClass('active');
		$navToggleSticky.addClass('active');
		$menuCategories.addClass('active');
		isMenuOpen = true;
		html.remove('menu-close-button menu-close-cursor-above');
		html.add('menu-open');
		$items.first().find('a').focus();
	}
	function closeMainMenu(outsideClick = false) {
		$navToggle.removeClass('active');
		$navToggleSticky.removeClass('active');
		$menuCategories.removeClass('active');
		resetItems();
		isMenuOpen = false;
		!outsideClick ? html.add('menu-close-button') : html.add('menu-close-cursor-above');
		html.remove('menu-open');
	}

	function openAccountAreaMenu() {
		if(isMenuOpen) {
			closeMainMenu();
			isMenuOpen = false;
		}
		$accountAreaMenuToggle.addClass('active');
		$accountAreaMenu.addClass('active');
		html.add('menu-open');
		$accountAreaMenu.find('a').first().focus();
	}
	function closeAccountAreaMenu() {
		$accountAreaMenuToggle.removeClass('active');
		$accountAreaMenu.removeClass('active');
		html.remove('menu-open');
	}

	function toggleCategoryContent(menuItem, force = false) {
		if (force && $(menuItem).data('index') === activeMenuCategory) {
			resetItems();
			activeMenuCategory = false;
		} else {
			activateCategoryContent(menuItem);
		}
	}
	function focusOnMenuItemForClosedCategory() {
		const focusedCategory = activeMenuCategory;
		toggleCategoryContent($itemsContents.filter(`[data-index="${focusedCategory}"]`), true);
		// focus na elemencie menu, którego zawartość była prezentowana przed escape
		$items.filter(`[data-index="${focusedCategory}"]`).focus();
	}

	function setEvents(){
		$navToggle.on('click', function() {
			isMenuOpen ? closeMainMenu() : openMainMenu();
		});
		$navToggleSticky.on('click', function() {
			isMenuOpen ? closeMainMenu() : openMainMenu();
		});
		if (isAccountArea) {
			$accountAreaMenuToggle.on('click', function(e) {
				e.preventDefault();
				$accountAreaMenu.hasClass('active') ? closeAccountAreaMenu() : openAccountAreaMenu();
			});
		}

		$items.on('mouseenter', function(){
			clearTimeout(headlessMenuDebounceTimer);
			const menuItem = this;
			headlessMenuDebounceTimer = setTimeout(function() {
				toggleCategoryContent(menuItem);
			}, DEBOUNCE_DELAY);
		}).on('mouseleave', function(e) {
			clearTimeout(headlessMenuDebounceTimer);
			const menuItem = this;
			headlessMenuDebounceTimer = setTimeout(function() {
				if(!$(e.target).closest($menuCategories).length){
					toggleCategoryContent(menuItem);
				}
			}, DEBOUNCE_DELAY);
		}).on('click', function(e) {
			e.preventDefault();
			toggleCategoryContent(this, true);
		}).on('keyup', function(e) {
			// podstawowa obsługa menu klawiaturą
			if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowRight') {
				e.preventDefault();
				toggleCategoryContent(this, true);
				$('.nav-category.active .nav-category-header a').first().focus();
			}
			if (e.key === 'ArrowUp') {
				e.preventDefault();
				if ($(e.target).prev().length) {
					$(e.target).prev().focus();
				}
			}
			if (e.key === 'ArrowDown') {
				e.preventDefault();
				if ($(e.target).next().length) {
					$(e.target).next().focus();
				}
			}
		});
		$menuCategories.on('mouseleave', function(){
			toggleCategoryContent(this);
		})

		$('body').on('click', function(e){
			if (isMenuOpen) {  // klikniecia poza menu głównym
				if (!$(e.target).closest($self).length && !$(e.target).closest($navToggleSticky).length) {
					closeMainMenu(true);
				}
			}
			if (isAccountArea && $accountAreaMenu.hasClass('active')) {  // klikniecia poza menu strefy klienta
				if (!$(e.target).closest($accountAreaMenu).length && !$(e.target).closest($accountAreaMenuToggle).length) {
					closeAccountAreaMenu();
				}
			}
		}).on('keyup', function(e) {
			if (e.key === 'Escape') {
				if (isMenuOpen) {
					if (activeMenuCategory !== null && activeMenuCategory !== false) {
						focusOnMenuItemForClosedCategory();
					} else {
						closeMainMenu();
						html.has('sticky') ? $navToggleSticky.focus() : $navToggle.focus();
					}
				}
				if (isAccountArea && $accountAreaMenu.hasClass('active')) {
					closeAccountAreaMenu();
					if (!html.has('sticky')) {
						$accountAreaMenuToggle.focus();
					}
				}
			}
			if (e.key === 'ArrowLeft' && isMenuOpen && activeMenuCategory !== null && activeMenuCategory !== false) {
				// obsługa klawisza strzałki w lewo jako powrót do menu kategorii
				focusOnMenuItemForClosedCategory();
			}
		}).on('focusin', function(e) {
			// zamknięcie menu głównego po wyjściu tabulatorem obszaru aktywnego menu
			if (isMenuOpen) {
				if (!$(e.target).closest($menuCategories).length && !$(e.target).closest($navToggleSticky).length) {
					closeMainMenu(true);
				}
			}
			// zamknięcie menu strefa klienta po wyjściu tabulatorem obszaru aktywnego menu
			if (isAccountArea && $accountAreaMenu.hasClass('active')) {
				if (!$(e.target).closest($accountAreaMenu).length && !$(e.target).closest($accountAreaMenuToggle).length) {
					closeAccountAreaMenu();
				}
			}
		});

	}

	function init() {
		if(!isInit){
			setElements();
			if($self.length){
				setEvents();
			}
		}
		isInit=false;
	}
	return {
		init
	};
});
